import Vue from 'vue'
import axios from 'axios'
import api from '@/helpers/api'
import store from '@/helpers/store'
import VueSweetalert2 from 'vue-sweetalert2';
import router from '@/common/router'
Vue.use(VueSweetalert2);

const axiosIns = axios.create({
    baseURL: api.API_ROOT,
    withCredentials: true,
})

axiosIns.interceptors.request.use(request => {
    request.headers.common['Accept'] = 'application/json'
    request.headers.common['Content-Type'] = 'application/json'

    return request
})

axiosIns.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error && error.response && (error.response.status === 401 || error.response.status === 419)) {
            store
                .dispatch('auth/logout')
                .then(() => {
                    localStorage.removeItem('user')
                    // window.location.href('/login')
                    window.location.assign('/login')
                    // this.$router.push({ path: api.LOGIN_ROUTE })
                })
            // window.location.reload()
        }
        else if (error && error.response && error.response.status === 503) {
            console.log('router', router);

            Vue.swal({
                heightAuto: false,
                title: '<img src="/maintanance.gif" alt="maintanance" style="max-height: 350px; margin-bottom: 20px; width: 100%; object-fit: contain;"/><br>' +
                    '<p style="font-size: 14px; text-align: center;">Ne cerem scuze pentru discomfortul creat.</p>' +
                    '<p style="font-size: 14px; text-align: center;">Momentan, lucrăm la aplicație pentru a îmbunătăți experiența ta pe Smis!</p>' +
                    '<p style="font-size: 14px; text-align: center;">Te rugăm să accesezi această pagină puțin mai târziu.</p>',
                customClass: 'swal-wide',
                showConfirmButton: true,
                confirmButtonText: 'Reîncarcă pagina',
                type: "success"
            }).then(function(){
                location.reload();
            })
        }

        return Promise.reject(error)
    }
)

Vue.prototype.$http = axiosIns

export default axiosIns
